var loadGoogleMapsApi = require('load-google-maps-api');

document.addEventListener('DOMContentLoaded',function() {
    
    const el = document.getElementById('map');
    let mapenable = false, int;

    const initMap = function() {
        loadGoogleMapsApi({
            key: el.getAttribute('data-key')
            }).then(function (googleMaps) {
            
            const lat = Number(el.getAttribute('data-lat')),
                  lng = Number(el.getAttribute('data-lng')),
                  myLatLng = new google.maps.LatLng(lat, lng);
        
            var map = new googleMaps.Map(el, {
                disableDefaultUI: true,
                center: myLatLng,
                zoom: 18,
            })
            
            var marker = new google.maps.Marker({ 
                position: { lat, lng }, 
                map: map, 
                icon: {
                    labelOrigin: new google.maps.Point(16,56),
                    url: "../img/assets/marker.svg",
                    scaledSize: new google.maps.Size(40, 40), // scaled size
                    origin: new google.maps.Point(0,0), // origin
                    anchor: new google.maps.Point(0, 0)
                },
                label: 'AmRest',
                animation: google.maps.Animation.DROP,	
            });
                    
        }).catch(function (error) {
            console.error(error)
        })
    };

    const init = function() {
    
        // Fire when show in viewport
        
        clearInterval(int); // for better performance
    
        int = setInterval(function() {
            let bottomOfObject = el.getBoundingClientRect().top + 200,
            bottomOfWindow = window.innerHeight;
    
            if ( bottomOfWindow > bottomOfObject ) {
                if (mapenable === false) {
                    initMap();
                    mapenable = true;
                }
        	}

        }, 50);        
    }

    el ? window.addEventListener('scroll', init) : false;
    el ? window.addEventListener('load', function() {

        let bottomOfObject = el.getBoundingClientRect().top,
            bottomOfWindow = window.innerHeight;
    
            if ( bottomOfWindow > bottomOfObject ) {
                if (mapenable === false) {
                    initMap();
                    mapenable = true;
                }
        	}
    }) : false;
    
}, false);


